<template>
	<table>
		<PatientRowHead type="success" :active-columns="activeColumns"></PatientRowHead>
		<tbody>
			<PatientResult v-for="(patient, index) in patients"
				v-bind:key="'result' + index"
				:patient="patient"
				:active-columns="activeColumns">
			</PatientResult>
		</tbody>
	</table>
</template>

<script>
import PatientList from './mixin/patient-list'
import PatientRowHead from '../head/Patient'
import PatientResult from '../row/PatientResult'

export default {
	name: 'patient-result-table',
	mixins: [PatientList],

	components: {
		PatientRowHead,
		PatientResult
	}
}
</script>

<style lang="scss" scoped>
</style>
